import { UserService } from '../../../../shared/services/user.service';
import { AuthService } from '../../../../shared/services/auth.service';
import { Router } from '@angular/router';
var UserComponent = (function () {
    function UserComponent(userService, auth, router) {
        var _this = this;
        this.userService = userService;
        this.auth = auth;
        this.router = router;
        this.isOpen = false;
        this.isLoggedIn = false;
        userService.currentUser.subscribe(function (user) {
            if (!user) {
                return;
            }
            _this.user = user;
        });
        auth.loggedIn.subscribe(function (value) {
            _this.isLoggedIn = value;
            if (_this.isLoggedIn) {
                _this.userService.getThisUser();
            }
        });
    }
    UserComponent.prototype.toggle = function () {
        this.isOpen = !this.isOpen || false;
        if (!this.isLoggedIn) {
            this.router.navigate(['/login']);
        }
    };
    UserComponent.prototype.logout = function () {
        this.auth.logout();
        this.router.navigate(['/login']);
    };
    return UserComponent;
}());
export { UserComponent };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/header/components/user/user.component.ts.pre-build-optimizer.js